import Config from '../interface/config';
import {Environment} from '../const';

const config: Config = {
  environment: Environment.STAGE,
  webuildbots: {
    host: 'https://backend-stage-portal.logicdialog.ai',
  },
};

export default config;
